import { FormattedMessage } from 'react-intl';
import { Divider, Button } from '@ets/design-system';

import { navigateToAdmin } from 'router/navigation';
import { useDispatch } from '_common/hooks';
import { setRedirectValidSession } from 'App/redux/appSlice';
import { useGetCurrentUserQuery, useSignOutMutation } from '_common/services/api/authority';

import ActiveAccount from './ActiveAccount/ActiveAccount';
import SavedAccounts from './SavedAccounts/SavedAccounts';

import styles from './UserPopover.module.scss';

type UserPopoverProps = {
  toggle: () => void;
};

const UserPopover = ({ toggle }: UserPopoverProps) => {
  const dispatch = useDispatch();
  const [signOut] = useSignOutMutation();

  const { data: currentUser } = useGetCurrentUserQuery();

  const goToAdministration = () => {
    if (currentUser?.other.admin_url) {
      navigateToAdmin(currentUser?.other.admin_url);
    }
  };

  const handleLogOut = () => {
    signOut(currentUser?.profile.id ?? '');
    dispatch(setRedirectValidSession(false));
  };

  return (
    <div className={styles.root}>
      <ActiveAccount toggle={toggle} />
      <Divider margin="1rem 0" />
      <SavedAccounts />
      <Divider margin="1rem 0" />
      <div className={styles.footer}>
        {currentUser?.is_superuser && (
          <Button
            fullWidth
            variant="standard"
            size="s"
            onClick={goToAdministration}
            style={{ margin: '0 0 1rem 0' }}
            testId="user-popover-administration"
          >
            <FormattedMessage id="storage.dropdowns.userProfile.administration" />
          </Button>
        )}
        <Button
          fullWidth
          size="s"
          variant="danger"
          onClick={handleLogOut}
          testId="user-popover-sign-out"
        >
          <FormattedMessage id="storage.dropdowns.userProfile.logout" />
        </Button>
      </div>
    </div>
  );
};

export default UserPopover;
